import { createPortal } from 'react-dom';

import ErrorNotification from 'components/ErrorNotification';
import InformationNotification from 'components/InformationNotification';
import SuccessNotification from 'components/SuccessNotification';
import WarningNotification from 'components/WarningNotification';

import useToast from 'hooks/useToast';

import { TEST_ID } from './constants';
import type { FunctionComponent, NotificationType, NotificationsMap, Props } from './types';

import styles from './styles.module.scss';

const notificationsMap: NotificationsMap = {
    error: ErrorNotification,
    info: InformationNotification,
    success: SuccessNotification,
    warning: WarningNotification
};

const Toast: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { setToastData, toastData } = useToast();
    const type = toastData()?.type;
    const text = toastData()?.text;

    const ToastComponent = type ? notificationsMap[type as NotificationType] : null;

    if (!type) {
        return null;
    }

    return createPortal(
        <div className={styles.toast} data-testid={testId}>
            <ToastComponent onClose={() => setToastData(null)} text={text} />
        </div>,

        document.body
    );
};

export default Toast;
